import PadraoModel from 'src/core/model/PadraoModel.js'

export default class PrecificadorModel extends PadraoModel {
  recurso = 'precificadores-versoes';
  microServico = 'automotor';
  include = '';
  searchFixo = null;
  nome = 'Veículos';

  colunasGrid = [];

  form = {
    id: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
